define('OutSystems/ClientRuntime/LanguageResources',["require", "exports", "./DataTypes", "./Injector", "./Injector/KnownServices", "./Logger"], function (require, exports, DataTypes_1, Injector_1, KnownServices_1, Logger) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BaseMessagesProvider = exports.ModuleMessageKeys = void 0;
    var MODULE_NAME = "BaseMessagesProvider";
    var ModuleMessageKeys;
    (function (ModuleMessageKeys) {
        ModuleMessageKeys["MandatoryValue"] = "Validation.Mandatory";
        ModuleMessageKeys["InvalidValuePrefix"] = "Validation.";
        ModuleMessageKeys["UpgradeComplete"] = "UpgradeComplete";
        ModuleMessageKeys["UpgradeRequiredDataLoss"] = "UpgradeRequiredDataLoss";
        ModuleMessageKeys["UpgradeRequired"] = "UpgradeRequired";
        ModuleMessageKeys["UpgradeFailedOnResources"] = "AppInitError.Resources";
        ModuleMessageKeys["UpgradeFailedOnDataModel"] = "AppInitError.DataModel";
        ModuleMessageKeys["UpgradeFailed"] = "AppInitError.Generic";
    })(ModuleMessageKeys || (exports.ModuleMessageKeys = ModuleMessageKeys = {}));
    var BaseMessagesProvider = (function () {
        function BaseMessagesProvider(translationResources) {
            var _this = this;
            this.messages = {};
            this.localeChangeHandler = function (data) {
                var _a;
                var translationsService = Injector_1.default.resolve(KnownServices_1.ServiceNames.TranslationsService);
                var localeService = Injector_1.default.resolve(KnownServices_1.ServiceNames.LocaleService);
                if (translationsService) {
                    var localeCodes = (_a = data.localeFamily) !== null && _a !== void 0 ? _a : [data.localeCode];
                    localeCodes.forEach(function (localeCode) {
                        var _a, _b;
                        if (_this.translationResources[localeCode]) {
                            Logger.trace(MODULE_NAME, "Adding translations for ".concat(localeCode, " locale."));
                            translationsService.add((_a = _this.translationResources[localeCode].translations) !== null && _a !== void 0 ? _a : {});
                            localeService.setCurrentLocaleRTL((_b = _this.translationResources[localeCode].isRTL) !== null && _b !== void 0 ? _b : false);
                        }
                        else {
                            Logger.trace(MODULE_NAME, "No translations found for ".concat(localeCode, " locale."));
                        }
                    });
                }
            };
            this.translationResources = translationResources !== null && translationResources !== void 0 ? translationResources : this.translationResources;
            if (this.translationResources) {
                var localeService = Injector_1.default.resolve(KnownServices_1.ServiceNames.LocaleService);
                if (localeService) {
                    var localeCode = localeService.getCurrentLocale();
                    var localeFamily = localeService.getCurrentLocaleFamily();
                    this.localeChangeHandler({ localeCode: localeCode, localeFamily: localeFamily });
                    Logger.trace(MODULE_NAME, "Subscribing handler for locale service.");
                    localeService.subscribe(this.localeChangeHandler);
                }
            }
        }
        BaseMessagesProvider.prototype.getMandatoryValueMessage = function () {
            return this.getMessage(ModuleMessageKeys.MandatoryValue, "Required Value!");
        };
        BaseMessagesProvider.prototype.getInvalidValueMessage = function (type) {
            return this.getMessage(ModuleMessageKeys.InvalidValuePrefix + DataTypes_1.DataTypes[type], "Invalid Value!");
        };
        BaseMessagesProvider.prototype.getApplicationUpgradeCompleteMessage = function () {
            return this.getMessage(ModuleMessageKeys.UpgradeComplete, "");
        };
        BaseMessagesProvider.prototype.getApplicationUpgradeRequiredMessage = function (canLoseData) {
            if (canLoseData) {
                return this.getMessage(ModuleMessageKeys.UpgradeRequiredDataLoss, "");
            }
            else {
                return this.getMessage(ModuleMessageKeys.UpgradeRequired, "");
            }
        };
        BaseMessagesProvider.prototype.getApplicationUpgradeFailedOnResourcesMessage = function () {
            return this.getMessage(ModuleMessageKeys.UpgradeFailedOnResources, "");
        };
        BaseMessagesProvider.prototype.getApplicationUpgradeFailedOnDataModelMessage = function () {
            return this.getMessage(ModuleMessageKeys.UpgradeFailedOnDataModel, "");
        };
        BaseMessagesProvider.prototype.getApplicationUpgradeFailedUnknownMessage = function () {
            return this.getMessage(ModuleMessageKeys.UpgradeFailed, "");
        };
        BaseMessagesProvider.prototype.getMessage = function (key, defaultMessage) {
            var _a;
            var msg = (_a = this.messages[key]) !== null && _a !== void 0 ? _a : defaultMessage;
            var translationSvc = Injector_1.default.resolve(KnownServices_1.ServiceNames.TranslationsService);
            if (translationSvc) {
                return translationSvc.getMessage(key, msg);
            }
            else {
                return msg;
            }
        };
        BaseMessagesProvider.prototype.setMessage = function (key, value) {
            this.messages[key] = value;
        };
        return BaseMessagesProvider;
    }());
    exports.BaseMessagesProvider = BaseMessagesProvider;
});
//# sourceMappingURL=LanguageResources.js.map;
